;(function () {
  'use strict'

  //  CONTRAST-37002: This is required in order to show our custom angular directives which doesn't work if you just use
  //  `ng-bind-html. This was developed to support the 'contrast-redacted-[group-id]' hover tooltips.
  angular
    .module('contrast.app-environment')
    .directive('bindHtmlCompile', function ($compile) {
      return function (scope, element, attrs) {
        // https://stackoverflow.com/questions/17417607/angular-ng-bind-html-and-directive-within-it
        var ensureCompileRunsOnce = scope.$watch(
          function (scope) {
            // watch the 'compile' expression for changes
            return scope.$eval(attrs.compile)
          },
          function (value) {
            // when the 'compile' expression changes
            // assign it into the current DOM
            element.html(value)

            // compile the new DOM and link it to the current
            // scope.
            // NOTE: we only compile .childNodes so that
            // we don't get into infinite loop compiling ourselves
            $compile(element.contents())(scope)

            // Use un-watch feature to ensure compilation happens only once.
            ensureCompileRunsOnce()
          }
        )
      }
    })
})()
